import {
  FaEdit,  FaKey,  FaWhatsapp,  FaChevronDown,  FaChevronLeft,
  FaChevronRight,  FaRoute,  FaDoorOpen} from "react-icons/fa";
import { IoMdHome } from "react-icons/io";
import { IoSettingsOutline, IoClose, IoMenu, IoSchool } from "react-icons/io5";
import { MdDelete,MdPointOfSale } from "react-icons/md";
import { RiBarChart2Line } from "react-icons/ri";
import { GrNotes } from "react-icons/gr";
import { BiSpreadsheet } from "react-icons/bi";
import { TfiRulerAlt2 } from "react-icons/tfi";
import { FaListCheck } from "react-icons/fa6";
const icons = {
  permisos: FaKey,
  capacitacion: IoSchool,
  cotizador: MdPointOfSale,
  whatsapp: FaWhatsapp,
  carretero: FaRoute,
  siniestralidad: BiSpreadsheet,
  edit: FaEdit,
  delete: MdDelete,
  chevrondown: FaChevronDown,
  chevronleft: FaChevronLeft,
  chevronright: FaChevronRight,
  estadísticas: RiBarChart2Line,
  menu: IoMenu,
  proyecto: TfiRulerAlt2,
  formalreclamación: GrNotes,
  configuración: IoSettingsOutline,
  controlobras:FaListCheck ,
  home: IoMdHome,
  close: IoClose,
  salir: FaDoorOpen,
};
const DynamicIcon = ({ iconName, color, size }) => {
  const IconComponent = icons[iconName];
  return IconComponent ? (
    <IconComponent className={`text-[${size}] ${color} mt-1 btnSuccess-100`} />
  ) : null; // Puedes personalizar tamaño y color
};
export default DynamicIcon